import React, { forwardRef } from 'react'
import * as S from './Field.styles'

const Field = forwardRef(
  ({ flexWeight, text, error, validateMessage, ...props }, ref) => {
    const hasRequiredError = error?.type === 'required'
    const hasValidationError = error?.type === 'validate'

    const useValidationMessage = validateMessage
      ? validateMessage
      : 'Valor inválido!'

    return (
      <S.Label flexWeight={flexWeight}>
        <S.TextLabel>{text}</S.TextLabel>
        <S.Input isRequiredError={error} {...props} ref={ref} />
        {hasRequiredError && <S.Error>Campo obrigatório!</S.Error>}
        {hasValidationError && <S.Error>{useValidationMessage}</S.Error>}
      </S.Label>
    )
  }
)

export default Field
